import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-05',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-05.component.html',
  styleUrls: []
})
export class Article05Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Vale a pena comprar imóvel em leilão? | Casato Brasil',
    description: 'Entenda quando vale a pena comprar imóvel em leilão, quais riscos analisar e quais cuidados tomar antes de dar um lance.'
  };
}
